import { Pipe, PipeTransform } from '@angular/core';

export const transformPlural = (
  value: number,
  singular: string,
  plural: string,
): string => (value === 1 ? singular : plural);

@Pipe({
  name: 'plural',
})
export class PluralPipe implements PipeTransform {
  transform(value: number, singular: string, plural: string): string {
    return transformPlural(value, singular, plural);
  }
}
